import { useEffect, useRef } from "react";
import { AppLayout } from "../layout/AppLayout";
import { Arrow, SwapArrow } from "../components/svg/Wallet/Wallet";
import { useNavigate } from "react-router-dom";
import { Transactions } from "../modules/wallet/Transactions";
import { useManageWallet } from "../api/settings/wallet";
import { formatAmount } from "../utils";
import { motion } from "framer-motion";

function Wallet() {
  const navigate = useNavigate();
  const { balance, getBalance, isLoading } = useManageWallet();
  const hasFetched = useRef(false);
  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      getBalance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <motion.div
        initial={{ opacity: 0, scale: 0.2 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className=" min-h-screen px-4 pt-10"
      >
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate("/settings")}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer  "
          />
          <p className="font-bold text-xl text-primary-black">Wallet</p>
        </div>

        {isLoading ? (
          <div
            style={{
              background: "linear-gradient(180deg, #0A0A0F 0%, #0D1440 100%)",
            }}
            className="flex flex-col bg-black justify-between gap-10 p-5 rounded-md my-10"
          >
            <div>
              <p className="text-[#FFFFFF80] text-sm font-medium">
                Available balance
              </p>
              <div className="h-8 bg-[#FFFFFF20] rounded mt-2 w-32"></div>
            </div>
            <div className="flex items-center justify-between gap-4">
              <div className="rounded-md bg-[#ECEFFF40] flex-1 p-2.5 h-16 animate-pulse"></div>
              <div className="rounded-md bg-[#ECEFFF40] flex-1 p-2.5 h-16 animate-pulse"></div>
              <div className="rounded-md bg-[#ECEFFF40] flex-1 p-2.5 h-16 animate-pulse"></div>
            </div>
          </div>
        ) : (
          <div
            style={{
              background: "linear-gradient(180deg, #0A0A0F 0%, #0D1440 100%)",
            }}
            className="flex  flex-col bg-black justify-between gap-10 p-5 rounded-md my-10 "
          >
            <div>
              <p className="text-[#FFFFFF80] text-sm font-medium">
                Available balance
              </p>
              <h4 className="text-[#fff] mt-2">
                {`₦${formatAmount(balance?.balance) ?? 0}`}
              </h4>
            </div>
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={() => navigate("/settings/wallet/fund/card-topup")}
                className="rounded-md bg-[#ECEFFF] flex-1 p-2.5 text-center flex items-center justify-center flex-col cursor-pointer"
              >
                <Arrow className="-rotate-45 w-4 h-5" />
                <p className="text-xs font-medium text-primary-black">
                  Receive
                </p>
              </div>
              <div
                onClick={() => navigate("/settings/wallet/withdraw")}
                className="cursor-pointer rounded-md bg-[#ECEFFF] flex-1 p-2.5 text-center flex items-center justify-center flex-col"
              >
                <Arrow className="rotate-[128deg] w-4 h-5" />
                <p className="text-xs font-medium text-primary-black">
                  Withdraw
                </p>
              </div>
              <div
                onClick={() => navigate("/settings/wallet/swap")}
                className="cursor-pointer rounded-md bg-[#ECEFFF] flex-1 p-2.5 text-center flex items-center justify-center flex-col"
              >
                <SwapArrow fill="#000000" className=" w-6 h-5 leading-tight" />
                <p className="text-xs font-medium text-primary-black">Swap</p>
              </div>
            </div>
          </div>
        )}
        <Transactions />
      </motion.div>
    </AppLayout>
  );
}

export default Wallet;
